import { twMerge } from 'tailwind-merge';
import { PencilSimple } from '@phosphor-icons/react';
import { useState, useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import { FieldWrapper } from '@/components/Form/FieldWrapper';
import { useImageUpload } from '@/hooks/useImageUpload';
import { getBase64 } from '@/utils/getBase64';
import { useNotificationStore } from '@/stores/notifications';

export const Image = ({
  onImageUpload = () => {},
  ImageUploadIcon = <PencilSimple size={52} className="text-white" />,
  wrapperClassName,
  overlayClassName,
  imageClassName,
  labelTextClassName,
  name,
  isEditable = true,
  imageSrc,
  imageTitle,
  DefaultIcon,
  error,
  label,
  registration = {},
  labelClassName = '',
  childrenClassName,
  maxSize = 5,
  ...imageProps
}) => {
  const { addNotification } = useNotificationStore();
  const imageRef = useRef(null);
  const imageInputRef = useRef(null);
  const [overlayActive, setOverlayActive] = useState(false);
  const handleClick = () => {
    imageInputRef.current.click();
  };
  const { handleImageFileInput, imageUrl } = useImageUpload({
    max_size: maxSize,
  });
  const { ref, onChange, ...rest } = registration;
  const handleFileUpload = async (event) => {
    try {
      const isUploadSuccess = await handleImageFileInput(event.target.files[0]);
      if (isUploadSuccess) {
        const image64 = await getBase64(event.target.files[0]);
        onImageUpload({ name, value: image64 });
      }
      if (onChange) {
        onChange(event);
      }
    } catch (error) {
      addNotification({ type: 'error', title: error.message });
    }
  };
  useEffect(() => {
    if (imageUrl) {
      imageRef.current.src = imageUrl;
    }
  }, [imageUrl]);
  return (
    <FieldWrapper
      error={error}
      onMouseEnter={() => setOverlayActive(true)}
      onMouseLeave={() => setOverlayActive(false)}
      wrapperClassName={twMerge('relative p-0 m-0', wrapperClassName)}
      className={twMerge('absolute top-0 left-0 w-full h-full', labelClassName)}
      label={label}
    >
      <button
        className={twMerge(
          'z-10 absolute top-0 left-0 bg-state-hover-overlay w-full h-full flex justify-center items-center cursor-pointer',
          overlayClassName,
          (!overlayActive || !isEditable) && `hidden`
        )}
        onClick={handleClick}
        type="button"
      >
        {isEditable && (
          <input
            type="file"
            className="hidden"
            ref={(e) => {
              if (ref) {
                ref(e);
              }
              imageInputRef.current = e;
            }}
            onChange={(event) => handleFileUpload(event)}
            {...rest}
          />
        )}

        {ImageUploadIcon}
      </button>
      <div
        className={twMerge(
          'w-full h-full absolute flex justify-center items-center top-0 left-0',
          overlayActive && isEditable && `hidden`
        )}
      >
        {DefaultIcon}
      </div>
      <img
        src={imageSrc}
        alt={imageTitle}
        className={twMerge(
          'relative block w-full h-full object-cover',
          imageClassName
        )}
        {...imageProps}
        ref={imageRef}
      />
    </FieldWrapper>
  );
};

Image.propTypes = {
  AS: PropTypes.string,
  onImageUpload: PropTypes.func,
  ImageUploadIcon: PropTypes.element,
  wrapperClassName: PropTypes.string,
  overlayClassName: PropTypes.string,
  imageClassName: PropTypes.string,
  name: PropTypes.string,
  isEditable: PropTypes.bool,
  imageSrc: PropTypes.string,
  imageTitle: PropTypes.string,
};
